module.exports = __webpack_public_path__ + "static/truck-leaving-a-depot-82477888b1ed609aaf73dc1b02a20b91.jpg";